export const FORM_TYPES = {
    higherVolume: 'MORE_VOLUME',
    higherIntent: 'HIGHER_INTENT',
}

export const DEFAULT_FORM_TYPE = FORM_TYPES.higherIntent

// Higher Intent forms add a review step before submission (Meta: is_optimized_for_quality)
export const isOptimizedForQuality = (formType) => (formType || DEFAULT_FORM_TYPE) === FORM_TYPES.higherIntent

// Form type of an existing Meta form, falling back to the quality flag when the type is not returned
export const resolveFormType = (form) => {
    if (form?.form_type === FORM_TYPES.higherIntent || form?.form_type === FORM_TYPES.higherVolume) {
        return form.form_type
    }

    return form?.is_optimized_for_quality ? FORM_TYPES.higherIntent : FORM_TYPES.higherVolume
}
